// extracted by mini-css-extract-plugin
export var fixed = "nav-module--fixed--07b58";
export var logo = "nav-module--logo--6e027";
export var nav = "nav-module--nav--b7415";
export var placeholder = "nav-module--placeholder--17221";
export var right = "nav-module--right--b7f39";
export var visible = "nav-module--visible--cc3e6";